import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Xmark, Flame } from "@gravity-ui/icons";
import { usePostHog } from "posthog-js/react";

const weekIcons = {
    Sunday: {
        inactive: "/week-icons/SundayStreakInactive.svg",
        active: "/week-icons/SundayStreakActive.svg"
    },
    Monday: {
        inactive: "/week-icons/MondayStreakInactive.svg",
        active: "/week-icons/MondayStreakActive.svg"
    },
    Tuesday: {
        inactive: "/week-icons/TuesdayStreakInactive.svg",
        active: "/week-icons/TuesdayStreakActive.svg"
    },
    Wednesday: {
        inactive: "/week-icons/WednesdayStreakInactive.svg",
        active: "/week-icons/WednesdayStreakActive.svg"
    },
    Thursday: {
        inactive: "/week-icons/ThursdayStreakInactive.svg",
        active: "/week-icons/ThursdayStreakActive.svg"
    },
    Friday: {
        inactive: "/week-icons/FridayStreakInactive.svg",
        active: "/week-icons/FridayStreakActive.svg"
    },
    Saturday: {
        inactive: "/week-icons/SaturdayStreakInactive.svg",
        active: "/week-icons/SaturdayStreakActive.svg"
    }
};

const StreakModal = ({ data, onClose }) => {
    const completedDays = data?.completed_days || [];
    const posthog = usePostHog();

    return (
        <div className="fixed md:top-4 top-8 left-1/2 transform md:-translate-x-[72px] -translate-x-1/2 z-50">
            <motion.div
                key="streakSection"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
            >
                <div className="bg-[#18181b] p-3 rounded-lg border border-[#444144] w-full text-white relative">
                    <button
                        className="absolute top-3 right-3 flex w-8 h-8 items-center justify-center text-white/50 hover:text-white bg-white/5 hover:bg-white/10 rounded-full transition duration-200"
                        onClick={() => {
                            // posthog.capture("Click-Close-StreakToast")
                            onClose();
                        }}
                    >
                        <Xmark className="w-4 h-4" />
                    </button>
                    <h3 className="text-base sm:text-base font-normal flex items-center gap-2">
                        <Flame className="w-4 h-4" />
                        Weekly streaks
                    </h3>
                    <p className="text-white/60 text-sm font-extralight" style={{ maxWidth: `272px` }} >
                        Create a track everyday for the next {7 - completedDays.length} days to get 3 bonus minutes of music free
                    </p>

                    <div className="flex w-full items-center mt-3 gap-3 ">
                        <div className="flex gap-1 pt-1 w-full">
                            {Object.entries(weekIcons).map(([day, icons]) => (
                                <div
                                    key={day}
                                    className="flex flex-col items-center min-w-[2rem]"
                                >
                                    <img
                                        src={completedDays.includes(day)
                                            ? icons.active
                                            : icons.inactive}
                                        alt={day}
                                        className="w-8 h-8"
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="border border-orange-500 text-white px-3 py-1 rounded-full text-xs transition whitespace-nowrap">
                            +3 mins
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default StreakModal;
